import {useTranslation} from "next-i18next";
import {ObjectInterfaceWithCity} from "../interfaces/ObjectInterface";
import {useRouter} from "next/router";
import {objectsAttributes} from "../models/objects";


function LastMinuteLabel(props: { object?: ObjectInterfaceWithCity | objectsAttributes, hidePrice?: boolean }) {

	const {object} = props;
	const {t} = useTranslation();
	const router = useRouter();
	if (!object || !object.rent_special_price_to || !object.rent_special_price_from) return <></>

	const specialPriceTo = new Date(object.rent_special_price_to!).getTime();
	const now = new Date().getTime();
	const specialPricePerNight = object.rent_special_price_eur_per_day ?? 0;
	const specialPricePerWeek = specialPricePerNight * 7;
	if (specialPriceTo <= now) {
		return <></>
	}

	const hidePrice = props.hidePrice ?? false;
	return <div className="my-2"><p className="text-leo-blue font-bold text-[16px] sm:text-[20px]">
		{t("components.vermietungDetailedTitle.lastMinutePrice")}{" "}
		{new Date(object.rent_special_price_from).toLocaleDateString(router.locale)} -{" "}
		{new Date(object.rent_special_price_to).toLocaleDateString(router.locale)}
	</p>
		{!hidePrice &&
			<p className="text-leo-blue font-bold">
				{`${t("common.price", {
					price: specialPricePerWeek.toLocaleString(
						router.locale
					)
				})} ${t("common.perWeek")} (${t("common.price", {
					price: specialPricePerNight.toLocaleString(
						router.locale
					)
				})} / ${t("common.night")})`}
			</p>
		}
	</div>
}

export default LastMinuteLabel;